
namespace Gamification.Gamification {
    export class ProdottiEsperienzeColumns {
        static columnsKey = 'Gamification.ProdottiEsperienze';
    }
}